export default __webpack_public_path__ + "static/media/research.e0da05c1.webp";